module.exports = __webpack_public_path__ + "e19.no2.07407e8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e19.no2.jpg
// module id = NdG9
// module chunks = 0